import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {ConfigContext} from "../../../context/ConfigContext";
import {Button, Label, Loader, SemanticCOLORS} from "semantic-ui-react";
import {
    customerReport,
    customerReportSummary,
    CustomerReportSummary,
    CustomerReportSummaryByCompany,
    CustomerReportSummaryByCompanyEntry,
    CustomerReportSummaryEntry,
    fetchCustomerReport,
    getMyRelevantCompanies,
    originalCustomerReportResponse
} from "../../../../style/page_with_sidebar";
import {CustomerReportFilter} from "../../../context/CustomerReport";
import {CompanyShort} from "../../../../../generated/api";
import {CustomerReportResponse} from "../../../../../generated-internal-monitoring/api";
import {useHistory} from "react-router-dom";

export function CustomerReportPopup() {

    const context = useContext(ConfigContext)
    const history = useHistory();

    const [customerReportPresent, setCustomerReportPresent] = useState(null)
    const [relevantCompanies, setRelevantCompanies] = useState<CompanyShort[]>([])
    const [responsibleManagers, setResponsibleManagers] = useState<string[]>([])
    const [storedFilter, setStoredFilter] = useState<CustomerReportFilter | null>(null)
    const [displayOnlyCompaniesWithIssues, setDisplayOnlyCompaniesWithIssues] = useState(true)
    const [displayOnlyNotAcknowledgedIssues, setDisplayOnlyNotAcknowledgedIssues] = useState(true)

    useEffect(() => {
        let issueFilter = localStorage.getItem("customerReportSummaryShowCompaniesWithoutIssues")
        let acknowledgedFilter = localStorage.getItem("customerReportSummaryShowOnlyNotAcknowledgedIssues")
        setDisplayOnlyCompaniesWithIssues(
            issueFilter === "true" || issueFilter == null
        )
        setDisplayOnlyNotAcknowledgedIssues(
            acknowledgedFilter === "true" || acknowledgedFilter == null
        )
        getMyRelevantCompanies(getResponsibleManagers()).then((myCompanies) => {
            setRelevantCompanies(myCompanies)
        })
        if (customerReport.value == null) {
            fetchCustomerReport(context).then((result) => {
                setCustomerReportPresent(result)
            })
        } else {
            setCustomerReportPresent(true)
        }
    }, [])

    useEffect(() => {
        localStorage.setItem("customerReportSummaryShowCompaniesWithoutIssues", displayOnlyCompaniesWithIssues.toString())
    }, [displayOnlyCompaniesWithIssues])

    useEffect(() => {
        localStorage.setItem("customerReportSummaryShowOnlyNotAcknowledgedIssues", displayOnlyNotAcknowledgedIssues.toString())
    }, [displayOnlyNotAcknowledgedIssues])

    if (customerReportPresent == null) return <div>
        <Loader active inline='centered'/>
        Customer Report is loading
    </div>

    if (!customerReportPresent) return <div style={{backgroundColor: "red"}}>
        unable to load Customer Report! please check the logs!
    </div>

    function getResponsibleManagers() {
        let storedFilter = JSON.parse(localStorage.getItem("customerReportFilter")) as CustomerReportFilter
        if (!storedFilter) {
            storedFilter = {
                responsibleManagers: [],
                addCompaniesWithoutResponsibleManager: true
            } as CustomerReportFilter
            localStorage.setItem("customerReportFilter", JSON.stringify(storedFilter))
        }
        let responsibleManagers = storedFilter.responsibleManagers || []
        setResponsibleManagers(responsibleManagers)
        setStoredFilter(storedFilter)
        return responsibleManagers
    }

    function filterInfo() {


        return <div
            style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "25px",
            }}>

            <h3>current Filters</h3>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "10px",
                }}>
                <div><h4>Responsible managers:</h4></div>
                <div>
                    {responsibleManagers.length > 0 ? responsibleManagers.map((m) =>
                        <Label>{m}</Label>) : "all"
                    }
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "10px",
                }}>
                <div><h4>include companies without manager:</h4></div>
                <div>
                    <h4 style={{color: storedFilter.addCompaniesWithoutResponsibleManager ? "green" : "red"}}>
                        {storedFilter.addCompaniesWithoutResponsibleManager ? "yes" : "no"}
                    </h4>
                </div>
            </div>
        </div>
    }

    function getReportIndexBySummaryName(name: string): number | undefined {
        // Mapping summary entry name -> CustomerReportPage accordion index
        // Indices per CustomerReportPage: 0 ApiGateway, 1 Sftp, 2 Logenios2Customer, 3 Customer2Logenios,
        // 4 Queue, 5 Status.json, 6 NeedsVerification, 7 ErrorFiles, 8 ETA, 9 MessageLog, 10 Scheduler
        const mapping: { [key: string]: number } = {
            "Company API Status": 0,
            "SFTP Sync Result": 1,
            "Customer File Status": 2,
            "Logenios File Status": 3,
            "Queues Status": 4,
            "Queue Status": 4,
            "Status JSON Report": 5,
            // "Needs Verification Files Count": 6, // not present in summary list by default
            "Error Files Count": 7,
            "ETA Calculation Health": 8,
            "Message Log Health": 9,
            "Scheduler Report Task Status": 10,
        };
        return mapping[name];
    }

    function goToCustomerReport(index: number | undefined) {
        if (index == null) return;
        const parts = history.location.pathname.split("/").filter(Boolean);
        const companyId = parts.length > 0 ? parts[0] : "";
        history.push({
            pathname: `/${companyId}/systemStatus`,
            // Use leading comma to align with CustomerReportPage's initial URL behavior
            search: `?tab=2&report=,${index}`
        });
    }

    function drawCustomerReportSummary(summary: CustomerReportSummary) {
        return <>
            {summary?.entries?.map(entry => {
                const index = getReportIndexBySummaryName(entry.name);
                return <Label
                    key={entry.name}
                    color={entry.color}
                    onClick={() => goToCustomerReport(index)}
                    style={{cursor: index != null ? "pointer" : undefined}}
                    title={index != null ? "Open this section in Customer Report" : undefined}
                >
                    {entry.name} - {entry.message}
                </Label>

            })
            }
        </>
    }

    function filterForAcknowledgedIssues(cr: CustomerReportResponse): CustomerReportResponse | undefined {

        try {
            let copy = JSON.parse(JSON.stringify(cr)) as CustomerReportResponse

            function filterAcksAndIgnored(items: any[] | undefined) {
                return items?.filter((item) => {
                    return item?.acknowledgementStatus?.enabled != true && item?.ignoreStatus?.enabled != true
                })
            }

            console.log(cr?.etaCalculatorHealth)

            copy.apiGatewayStatus.companyApiStatus = filterAcksAndIgnored(cr?.apiGatewayStatus?.companyApiStatus);
            copy.fileSystemWorkerStatus.sftpSyncResults = filterAcksAndIgnored(cr?.fileSystemWorkerStatus?.sftpSyncResults);
            copy.fileSystemWorkerStatus.customerOldFiles = filterAcksAndIgnored(cr?.fileSystemWorkerStatus?.customerOldFiles);
            copy.fileSystemWorkerStatus.logeniosOldFiles = filterAcksAndIgnored(cr?.fileSystemWorkerStatus?.logeniosOldFiles);
            copy.fileSystemWorkerStatus.attachmentOldFiles = filterAcksAndIgnored(cr?.fileSystemWorkerStatus?.attachmentOldFiles);
            copy.queueStatus.companies = filterAcksAndIgnored(cr?.queueStatus?.companies);
            copy.statusJsonReport.companies = filterAcksAndIgnored(cr?.statusJsonReport?.companies);
            copy.needsVerificationFilesCount.companies = filterAcksAndIgnored(cr?.needsVerificationFilesCount?.companies);
            copy.errorFilesCount.companies = filterAcksAndIgnored(cr?.errorFilesCount?.companies);
            copy.etaCalculatorHealth.workerThreads = filterAcksAndIgnored(cr?.etaCalculatorHealth?.workerThreads);
            copy.messageLogHealth.companies = filterAcksAndIgnored(cr?.messageLogHealth?.companies);
            copy.schedulerReportTaskStatus.companies = filterAcksAndIgnored(cr?.schedulerReportTaskStatus?.companies);

            return copy
        } catch (e) {
            return undefined
        }

    }

    return <div style={{
        display: "flex",
        flexDirection: "column",
        width: "1200px",
    }}>
        {filterInfo()}
        <div style={{
            display: "flex",
            flexDirection: "row",
        }}>
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
            }}>
                <h3>{responsibleManagers.length == 0 ? "your" : "filtered"} companies: </h3>

                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}>

                    <Button
                        primary={displayOnlyCompaniesWithIssues}
                        onClick={() => {
                            setDisplayOnlyCompaniesWithIssues(!displayOnlyCompaniesWithIssues)
                        }}
                    >
                        {displayOnlyCompaniesWithIssues ? "issue filter (on)" : "issue filter (off)"}
                    </Button>
                    <Button
                        primary={displayOnlyNotAcknowledgedIssues}
                        onClick={() => {
                            setDisplayOnlyNotAcknowledgedIssues(!displayOnlyNotAcknowledgedIssues)
                        }}
                    >
                        {displayOnlyNotAcknowledgedIssues ? "acknowledged filter (on)" : "acknowledged filter (off)"}
                    </Button>
                </div>
                {displayCustomerReportSummaryByCompany(
                    createCustomerReportSummaryByCompany(
                        displayOnlyNotAcknowledgedIssues ? filterForAcknowledgedIssues(originalCustomerReportResponse.value) : originalCustomerReportResponse.value
                    ),
                    relevantCompanies,
                    displayOnlyCompaniesWithIssues
                )}
            </div>
            <div style={{
                width: "2px",
                backgroundColor: "gray",
                height: "400px",
                margin: "0 20px",
            }}/>
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
            }}>
                <h3>with your filters: </h3>
                {drawCustomerReportSummary(customerReportSummary.value)}
            </div>
            <div style={{
                width: "2px",
                backgroundColor: "gray",
                height: "400px",
                margin: "0 20px",
            }}/>
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
            }}>
                <h3>for all: </h3>
                {drawCustomerReportSummary(createCustomerReportSummary(originalCustomerReportResponse.value))}
            </div>

        </div>

    </div>
}

function hasMonitoringFlags(entry: unknown): entry is { acknowledgementStatus?: { enabled?: boolean } | null, ignoreStatus?: { enabled?: boolean } | null } {
    if (entry == null || typeof entry !== 'object') return false;
    const anyEntry = entry as { [key: string]: any };
    // We only care if keys exist and are objects; values are optional
    const ack = anyEntry["acknowledgementStatus"];
    const ign = anyEntry["ignoreStatus"];
    const ackOk = ack == null || typeof ack === 'object';
    const ignOk = ign == null || typeof ign === 'object';
    return ackOk && ignOk;
}

function isProblematic(entry: unknown): boolean {
    if (!hasMonitoringFlags(entry)) return true; // If flags are absent, treat as problematic (not acknowledged)
    return entry?.acknowledgementStatus?.enabled !== true;
}

function isIgnoredButNotAcknowledged(entry: unknown): boolean {
    if (!hasMonitoringFlags(entry)) return false;
    return entry?.ignoreStatus?.enabled === true && entry?.acknowledgementStatus?.enabled !== true;
}

function buildSummary(
    name: string,
    directCount: number,
    ignoredUnackCount: number,
    messageParts: string[],
    color: SemanticCOLORS
): CustomerReportSummaryEntry {
    let message = messageParts.length > 0
        ? `${messageParts.join(" , ")} (${directCount} total, ${ignoredUnackCount} ignored by dev)`
        : "All is well";


    return {
        name,
        color,
        message,
    };
}

export function createCustomerReportSummary(cr: CustomerReportResponse) {

    if (!cr) {
        console.error("createCustomerReportSummary called with null or undefined CustomerReport")
        return {} as CustomerReportSummary
    }

    function summarizeCompanyApiStatus(cr: CustomerReportResponse) {
        let color: SemanticCOLORS = 'green';
        const statuses = cr?.apiGatewayStatus?.companyApiStatus || [];

        const directWarnings = statuses.filter(s =>
            s.status === 'WARNING' &&
            !s?.ignoreStatus?.enabled
        );
        const directErrors = statuses.filter(s =>
            s.status !== 'OK' &&
            s.status !== 'WARNING' &&
            // !s?.ignoreStatus?.enabled &&
            !s?.acknowledgementStatus?.enabled
        );
        const unacknowledgedIgnores = statuses.filter(s =>
            s.status !== 'OK' &&
            s?.ignoreStatus?.enabled === true &&
            s?.acknowledgementStatus?.enabled !== true
        );

        const w = directWarnings.length;
        const e = directErrors.length;
        const u = unacknowledgedIgnores.length;

        let message = 'All is well';
        if (w > 0 || e > 0 || u > 0) {
            if (e > 0 && u === 0) {
                color = 'red';
                message = ` (${w} WARNINGS) - (${e} ERRORS)`;
            } else if (e === 0 && w > 0 && u === 0) {
                color = 'yellow';
                message = ` (${w} WARNINGS)`;
            } else if (e === 0 && w === 0 && u > 0) {
                color = 'orange';
                message = ` (${u} ignored by dev but not by pm)`;
            } else if (e > 0 && u > 0) {
                color = 'red';
                message = ` (${w} WARNINGS) - (${e} ERRORS), and ${u} ignored by dev but not by pm`;
            } else if (e === 0 && w > 0 && u > 0) {
                color = 'orange';
                message = ` (${w} WARNINGS), and ${u} ignored by dev but not by pm`;
            }
        }

        return {
            name: 'Company API Status',
            color,
            message
        } as CustomerReportSummaryEntry;
    }


    function summarizeSftpSyncResult(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "SFTP Sync Result";
        const results = cr?.fileSystemWorkerStatus?.sftpSyncResults ?? [];

        const directErrors = results.filter(r => r.status !== "SUCCESS" && isProblematic(r));
        const ignoredUnacknowledged = results.filter(r => r.status !== "SUCCESS" && isIgnoredButNotAcknowledged(r));

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} error(s)`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }



    function summarizeCustomerFileHealthReport(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "Customer File Status";
        const files = cr?.fileSystemWorkerStatus?.customerOldFiles ?? [];

        const directErrors = files.filter(f => f.healthy === false && isProblematic(f));
        const ignoredUnacknowledged = files.filter(f => f.healthy === false && isIgnoredButNotAcknowledged(f));

        const totalOldFiles = directErrors.reduce((sum, f) => sum + (f.oldFileAmount ?? 1), 0);

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} customers, ${totalOldFiles} old file(s)`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }


    function summarizeLogeniosFileHealthReport(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "Logenios File Status";
        const files = cr?.fileSystemWorkerStatus?.logeniosOldFiles ?? [];

        const directErrors = files.filter(f => f.healthy === false && isProblematic(f));
        const ignoredUnacknowledged = files.filter(f => f.healthy === false && isIgnoredButNotAcknowledged(f));

        const totalOldFiles = directErrors.reduce((sum, f) => sum + (f.oldFileAmount ?? 1), 0);

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} customers, ${totalOldFiles} old file(s)`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }

    function summarizeQueueStatus(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "Queues Status";
        const queues = cr?.queueStatus?.companies ?? [];

        const directErrors = queues.filter(q => q.unprocessedEventsOlderThanFiveMinutes > 0 && isProblematic(q));
        const ignoredUnacknowledged = queues.filter(q => q.unprocessedEventsOlderThanFiveMinutes > 0 && isIgnoredButNotAcknowledged(q));

        const totalEvents = directErrors.reduce((sum, q) => sum + q.unprocessedEventsOlderThanFiveMinutes, 0);

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} queues, ${totalEvents} unprocessed events`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }

    function summarizeQueuedEventsErrorStatus(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "Queued Events Error Status";
        const errorQueues = cr?.queuedEventsErrorStatus?.companies ?? [];

        const directErrors = errorQueues.filter(q => q.processedEventsWithErrorCount > 0 && isProblematic(q));
        const ignoredUnacknowledged = errorQueues.filter(q => q.processedEventsWithErrorCount > 0 && isIgnoredButNotAcknowledged(q));

        const totalErrorEvents = directErrors.reduce((sum, q) => sum + q.processedEventsWithErrorCount, 0);

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} companies, ${totalErrorEvents} processed error events`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }



    function summarizeStatusJsonReport(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "Status JSON Report";
        const companies = cr?.statusJsonReport?.companies ?? [];

        const directErrors = companies.filter(c => c.healthy === false && isProblematic(c));
        const ignoredUnacknowledged = companies.filter(c => c.healthy === false && isIgnoredButNotAcknowledged(c));

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} unhealthy company(ies)`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }


    function summarizeNeedsVerificationFilesCount(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "Needs Verification Files Count";
        const companies = cr?.needsVerificationFilesCount?.companies ?? [];

        const directErrors = companies.filter(c =>
            (c.filesOlderThanFiveMinutes ?? 0) > 0 && isProblematic(c)
        );
        const ignoredUnacknowledged = companies.filter(c =>
            (c.filesOlderThanFiveMinutes ?? 0) > 0 && isIgnoredButNotAcknowledged(c)
        );

        const totalFiles = directErrors.reduce(
            (sum, c) => sum + (c.filesOlderThanFiveMinutes ?? 0),
            0
        );

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} company(ies), ${totalFiles} file(s) older than 5 min`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }


    function summarizeErrorFilesCount(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "Error Files Count";
        const companies = cr?.errorFilesCount?.companies ?? [];

        const directErrors = companies.filter(
            c => (c.filesOlderThanFiveMinutes ?? 0) > 0 && isProblematic(c)
        );
        const ignoredUnacknowledged = companies.filter(
            c => (c.filesOlderThanFiveMinutes ?? 0) > 0 && isIgnoredButNotAcknowledged(c)
        );

        const totalFiles = directErrors.reduce(
            (sum, c) => sum + (c.filesOlderThanFiveMinutes ?? 0),
            0
        );

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} company(ies), ${totalFiles} file(s) older than 5 min`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }

    function summarizeEtaCalculationHealth(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "ETA Calculation Health";
        const workers = cr?.etaCalculatorHealth?.workerThreads ?? [];

        const directErrors = workers.filter(w => w.isHealthy === false && isProblematic(w));
        const ignoredUnacknowledged = workers.filter(w => w.isHealthy === false && isIgnoredButNotAcknowledged(w));

        const totalUnhealthy = directErrors.length;

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} unhealthy worker(s)`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }


    function summarizeMessageLogHealth(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "Message Log Health";
        const companies = cr?.messageLogHealth?.companies ?? [];

        const directErrors = companies.filter(
            c => c.sendErrors > 0 && isProblematic(c)
        );
        const ignoredUnacknowledged = companies.filter(
            c => c.sendErrors > 0 && isIgnoredButNotAcknowledged(c)
        );

        const totalErrors = directErrors.reduce(
            (sum, c) => sum + c.sendErrors,
            0
        );

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} company(ies) with ${totalErrors} send error(s)`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored by dev but not by pm`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }


    function summarizeSchedulerReportTaskStatus(cr: CustomerReportResponse): CustomerReportSummaryEntry {
        const name = "Scheduler Report Task Status";
        const companies = cr?.schedulerReportTaskStatus?.companies ?? [];

        const directErrors = companies.filter(
            c => (c.unhealthyTasks ?? 0) > 0 && isProblematic(c)
        );
        const ignoredUnacknowledged = companies.filter(
            c => (c.unhealthyTasks ?? 0) > 0 && isIgnoredButNotAcknowledged(c)
        );

        const totalUnhealthy = directErrors.reduce(
            (sum, c) => sum + (c.unhealthyTasks ?? 0),
            0
        );

        let color: SemanticCOLORS = "green";
        let parts: string[] = [];

        if (directErrors.length > 0) {
            parts.push(`${directErrors.length} company(ies) with ${totalUnhealthy} unhealthy task(s)`);
            color = "red";
        }

        if (ignoredUnacknowledged.length > 0) {
            parts.push(`${ignoredUnacknowledged.length} ignored but not acknowledged`);
            color = color === "green" ? "orange" : color;
        }

        return buildSummary(name, directErrors.length, ignoredUnacknowledged.length, parts, color);
    }


    let summaryEntries = []
    summaryEntries.push(summarizeCompanyApiStatus(cr))
    summaryEntries.push(summarizeSftpSyncResult(cr))
    summaryEntries.push(summarizeCustomerFileHealthReport(cr))
    summaryEntries.push(summarizeLogeniosFileHealthReport(cr))
    summaryEntries.push(summarizeQueueStatus(cr))
    summaryEntries.push(summarizeQueuedEventsErrorStatus(cr))
    summaryEntries.push(summarizeStatusJsonReport(cr))
    //summaryEntries.push(summarizeNeedsVerificationFilesCount(cr))
    summaryEntries.push(summarizeErrorFilesCount(cr))
    summaryEntries.push(summarizeEtaCalculationHealth(cr))
    summaryEntries.push(summarizeMessageLogHealth(cr))
    summaryEntries.push(summarizeSchedulerReportTaskStatus(cr))

    let summary = {} as CustomerReportSummary
    summary.entries = summaryEntries
    summary.allHealthy = summaryEntries.filter((item) => {
        return item.color != "green"
    }).length == 0
    let worstColor = "green"
    summaryEntries.forEach((item) => {
        if (item.color == "red") {
            worstColor = "red"
        } else if (item.color == "yellow" && worstColor != "red") {
            worstColor = "yellow"
        }
    })
    summary.color = worstColor as SemanticCOLORS

    return summary

}

export function displayCustomerReportSummaryByCompany(
    summary: CustomerReportSummaryByCompany,
    relevantCompanies: CompanyShort[] = [],
    displayOnlyCompaniesWithIssues = false
) {

    function findIssuesByCompanyId(companyId: string): CustomerReportSummaryByCompanyEntry | undefined {
        return summary.companies.find((entry) => entry.companyId === companyId);
    }

    let companiesDisplayed: {
        company: CompanyShort,
        summary: CustomerReportSummaryByCompanyEntry | undefined
    }[] = []

    relevantCompanies.forEach((company) => {
        let companySummary: CustomerReportSummaryByCompanyEntry = findIssuesByCompanyId(company._id);
        companiesDisplayed.push({
            "company": company,
            "summary": companySummary
        });
    })
    companiesDisplayed.sort((a, b) => {
        let aIssues = a.summary?.issues?.length ?? 0
        let bIssues = b.summary?.issues?.length ?? 0
        return bIssues - aIssues; // Sort by number of issues, descending
    })

    if (displayOnlyCompaniesWithIssues) {
        companiesDisplayed = companiesDisplayed.filter((companyWithSummary) => {
            return companyWithSummary.summary && companyWithSummary.summary.issues.length > 0;
        });
    }
    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
    }}>
        {companiesDisplayed.map((companyWithSummary) => {
            let company = companyWithSummary.company;
            let companySummary = companyWithSummary.summary;

            return <div key={company._id} style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid gray",
                padding: "2px",
                borderRadius: "5px"
            }}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        paddingBottom: "0px"
                    }}
                >
                    <h4
                        style={{
                            padding: "0px",
                            margin: "0px",
                            marginRight: "10px"
                        }}
                    >
                        {company.name}
                    </h4>

                    <span
                        style={{
                            fontSize: 11,
                            alignSelf: "flex-start"
                        }}
                    >
                        ({company._id})
                    </span>
                </div>
                {companySummary && companySummary.issues.map((issue, index) => {
                    return <Label
                        key={index}
                        color={issue.severity === "error" ? "red" : issue.severity === "warning" ? "yellow" : "green"}
                    >
                        [{issue.checkName}] {issue.issueMessage}
                    </Label>
                })}
                {!companySummary && <Label color={"green"}>No issues reported</Label>}
            </div>
        })}
    </div>
}

export function createCustomerReportSummaryByCompany(cr: CustomerReportResponse): CustomerReportSummaryByCompany {

    function summarizeCompanyApiStatus(cr: CustomerReportResponse) {
        const checkName = "Company API Status"
        let companiesWithApiStatusIssue: CustomerReportSummaryByCompanyEntry[] = []
        cr?.apiGatewayStatus?.companyApiStatus?.forEach((company) => {
            switch (company.status) {
                case "OK":
                    break;
                case "WARNING":
                    companiesWithApiStatusIssue.push({
                        companyId: company.companyId,
                        companyName: company.companyName,
                        issues: [{
                            checkName: checkName,
                            issueMessage: "warning for api status",
                            severity: "warning",
                            link: "" //TODO: add link to company details
                        }]
                    })
                    break;
                case "ERROR":
                    companiesWithApiStatusIssue.push({
                        companyId: company.companyId,
                        companyName: company.companyName,
                        issues: [{
                            checkName: checkName,
                            issueMessage: "error for api status",
                            severity: "error",
                            link: "" //TODO: add link to company details
                        }]
                    })
                    break;
            }
        })
        return companiesWithApiStatusIssue
    }

    function summarizeSftpSyncResult(cr: CustomerReportResponse) {
        const checkName = "SFTP Sync Result"
        let companiesWithSftpSyncIssues: CustomerReportSummaryByCompanyEntry[] = []
        cr?.fileSystemWorkerStatus.sftpSyncResults.forEach((company) => {
            if (company.status != "SUCCESS") {
                companiesWithSftpSyncIssues.push({
                    companyId: company.companyId,
                    companyName: company.name,
                    issues: [{
                        checkName: checkName,
                        issueMessage: "sftp sync failed",
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })
        return companiesWithSftpSyncIssues
    }

    function summarizeCustomerFileHealthReport(cr: CustomerReportResponse) {
        const checkName = "Customer File Status"
        let companiesWithFileHealthIssues: CustomerReportSummaryByCompanyEntry[] = []
        cr?.fileSystemWorkerStatus.customerOldFiles.forEach((company) => {
            if (!company.healthy) {
                companiesWithFileHealthIssues.push({
                    companyId: company.companyId,
                    companyName: company.companyName,
                    issues: [{
                        checkName: checkName,
                        issueMessage: "unhealthy files - " + company.oldFileAmount + " old files",
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })
        return companiesWithFileHealthIssues
    }

    function summarizeLogeniosFileHealthReport(cr: CustomerReportResponse) {
        const checkName = "Customer File Status"
        let companiesWithFileHealthIssues: CustomerReportSummaryByCompanyEntry[] = []
        cr?.fileSystemWorkerStatus.logeniosOldFiles.forEach((company) => {
            if (!company.healthy) {
                companiesWithFileHealthIssues.push({
                    companyId: company.companyId,
                    companyName: company.companyName,
                    issues: [{
                        checkName: checkName,
                        issueMessage: "unhealthy files - " + company.oldFileAmount + " old files",
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })
        return companiesWithFileHealthIssues
    }

    function summarizeQueueStatus(cr: CustomerReportResponse) {
        const checkName = "Queue Status"
        let companiesWithQueueIssues: CustomerReportSummaryByCompanyEntry[] = []
        cr?.queueStatus?.companies?.forEach((company) => {
            if (company.unprocessedEventsOlderThanFiveMinutes > 0) {
                companiesWithQueueIssues.push({
                    companyId: company.companyId,
                    companyName: company.name,
                    issues: [{
                        checkName: checkName,
                        issueMessage: "unprocessed events older than 5min - " + company.unprocessedEventsOlderThanFiveMinutes,
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })
        return companiesWithQueueIssues
    }

    function summarizeQueuedEventsErrorStatus(cr: CustomerReportResponse) {
        const checkName = "Queued Events Error Status"
        let companiesWithErrorIssues: CustomerReportSummaryByCompanyEntry[] = []
        cr?.queuedEventsErrorStatus?.companies?.forEach((company) => {
            if (company.processedEventsWithErrorCount > 0) {
                companiesWithErrorIssues.push({
                    companyId: company.companyId,
                    companyName: company.name,
                    issues: [{
                        checkName: checkName,
                        issueMessage: `processed events with errors - ${company.processedEventsWithErrorCount}${company.errorSummary ? ` (${company.errorSummary})` : ''}`,
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })
        return companiesWithErrorIssues
    }

    function summarizeStatusJsonReport(cr: CustomerReportResponse) {
        const checkName = "Status JSON Report"
        let companiesWithStatusJsonIssues: CustomerReportSummaryByCompanyEntry[] = []
        cr?.statusJsonReport?.companies?.forEach((company) => {
            if (!company?.ignoreStatus?.enabled && !company.healthy) {
                companiesWithStatusJsonIssues.push({
                    companyId: company.companyId,
                    companyName: company.name,
                    issues: [{
                        checkName: checkName,
                        issueMessage: "unhealthy status json",
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })
        return companiesWithStatusJsonIssues
    }

    function summarizeNeedsVerificationFilesCount(cr: CustomerReportResponse) {
        const checkName = "Needs Verification Files Count"
        let companiesWithStatusJsonIssues: CustomerReportSummaryByCompanyEntry[] = []

        cr?.needsVerificationFilesCount?.companies.forEach((company) => {
            if (company.filesOlderThanFiveMinutes > 0) {
                companiesWithStatusJsonIssues.push({
                    companyId: company.companyId,
                    companyName: company.name,
                    issues: [{
                        checkName: checkName,
                        issueMessage: company.filesOlderThanFiveMinutes + " files older than 5min",
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })
        return companiesWithStatusJsonIssues

    }

    function summarizeErrorFilesCount(cr: CustomerReportResponse) {
        const checkName = "Error Files Count"
        let companiesWithStatusJsonIssues: CustomerReportSummaryByCompanyEntry[] = []

        cr?.errorFilesCount?.companies.forEach((company) => {
            if (company.filesOlderThanFiveMinutes > 0) {
                companiesWithStatusJsonIssues.push({
                    companyId: company.companyId,
                    companyName: company.name,
                    issues: [{
                        checkName: checkName,
                        issueMessage: company.filesOlderThanFiveMinutes + " files older than 5min",
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })

        return companiesWithStatusJsonIssues
    }

    function summarizeEtaCalculationHealth(cr: CustomerReportResponse) {
        const checkName = "ETA Calculation Health"
        let companiesWithEtaIssues: CustomerReportSummaryByCompanyEntry[] = []
        cr?.etaCalculatorHealth?.workerThreads?.forEach((company) => {
            if (!company.isHealthy && !company?.ignoreStatus?.enabled) {
                companiesWithEtaIssues.push({
                    companyId: company.companyId,
                    companyName: company.name,
                    issues: [{
                        checkName: checkName,
                        issueMessage: "unhealthy ETA calculation worker",
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })
        return companiesWithEtaIssues
    }

    function summarizeMessageLogHealth(cr: CustomerReportResponse) {
        const checkName = "Message Log Health"

        let companiesWithMessageLogIssues: CustomerReportSummaryByCompanyEntry[] = []

        cr?.messageLogHealth?.companies?.forEach((company) => {
            if (company.sendErrors > 0) {
                companiesWithMessageLogIssues.push({
                    companyId: company.companyId,
                    companyName: company.name,
                    issues: [{
                        checkName: checkName,
                        issueMessage: company.sendErrors + " total send errors",
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                } as CustomerReportSummaryByCompanyEntry)
            }
        })

        return companiesWithMessageLogIssues
    }

    function summarizeSchedulerReportTaskStatus(cr: CustomerReportResponse) {
        const checkName = "Scheduler Report Task Status"
        let companiesWithSchedulerIssues: CustomerReportSummaryByCompanyEntry[] = []
        cr?.schedulerReportTaskStatus?.companies?.forEach((company) => {
            if (company?.ignoreStatus?.enabled != true && company.unhealthyTasks > 0) {
                companiesWithSchedulerIssues.push({
                    companyId: company.companyId,
                    companyName: company.companyName,
                    issues: [{
                        checkName: checkName,
                        issueMessage: "unhealthy scheduler tasks - " + company.unhealthyTasks + " unhealthy tasks",
                        severity: "error",
                        link: "" //TODO: add link to company details
                    }]
                })
            }
        })
        return companiesWithSchedulerIssues
    }

    let result = {} as CustomerReportSummaryByCompany;
    result.companies = []


    let companiesWithApiStatusIssue = summarizeCompanyApiStatus(cr)
    let companiesWithSftpSyncIssues = summarizeSftpSyncResult(cr)
    let companiesWithCustomerFileHealthIssues = summarizeCustomerFileHealthReport(cr)
    let companiesWithLogeniosFileHealthIssues = summarizeCustomerFileHealthReport(cr)
    let companiesWithQueueIssues = summarizeQueueStatus(cr)
    let companiesWithQueuedEventsErrorIssues = summarizeQueuedEventsErrorStatus(cr)
    let companiesWithStatusJsonIssues = summarizeStatusJsonReport(cr)
    //let needsVerificationFilesCount = summarizeNeedsVerificationFilesCount(cr)
    let errorFilesCount = summarizeErrorFilesCount(cr)
    let etaCalculationHealth = summarizeEtaCalculationHealth(cr)
    let messageLogHealth = summarizeMessageLogHealth(cr)
    let schedulerReportTaskStatus = summarizeSchedulerReportTaskStatus(cr)


    let all = [
        ...companiesWithApiStatusIssue,
        ...companiesWithSftpSyncIssues,
        ...companiesWithCustomerFileHealthIssues,
        ...companiesWithLogeniosFileHealthIssues,
        ...companiesWithQueueIssues,
        ...companiesWithQueuedEventsErrorIssues,
        ...companiesWithStatusJsonIssues,
        //...needsVerificationFilesCount,
        ...errorFilesCount,
        ...etaCalculationHealth,
        ...messageLogHealth,
        ...schedulerReportTaskStatus
    ]

    let companiesWithIssues = []

    all.forEach((entry) => {

        if (companiesWithIssues.findIndex((c) => c.companyId === entry.companyId) === -1) {
            companiesWithIssues.push(entry)
        } else {
            let existingEntry = companiesWithIssues.find((c) => c.companyId === entry.companyId);
            if (existingEntry) {
                existingEntry.issues.push(...entry.issues);
            }
        }
    })


    result.companies = companiesWithIssues

    return result
}